

















































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import Forms from '@/components/Forms.vue';
import { patchConnectedUser, getConnectedUser, uploadUserPhoto } from '@/api/api';
import User from '@/models/User';
import moment from 'moment';
import get from 'lodash/get';
import router from '@/router';
import AuthModule from '@/store/AuthModule';
import { getValueCookie } from "@/utils/cookie";
import { BACKEND_URL } from '@/helpers/constants';

let origin: string | null = null;

@Component({
    beforeRouteEnter: async (to, from, next) => {
        if (from.name === 'subscription') {
            origin = 'subscription';
        } else {
            origin = null;
        }

        next();
    },
    components: {
        Forms,
        VxBreadcrumb,
    },
})
export default class ProfilePrescriber extends Vue {
    error: string | null = null;
    errors: any = {};
    user: User | null = null;
    loading: boolean = false;
    type: string = 'edit';
    defaultImages: any | null = null;



    get firstname() {
                return AuthModule.firstname;
            }


        get lastname() {
            return AuthModule.lastname;
        }

        get logo() {
            return AuthModule.logo;
        }

        get backendUrl() {
            return BACKEND_URL;
        }





    get items() {
        return [
            {
                name: 'civility',
                label: 'Civilité *',
                type: 'select',
                errorMessage: 'La civilité est requise',
                required: true,
                items: [
                    { text: 'Monsieur', value: 'Monsieur' },
                    { text: 'Madame', value: 'Madame' },
                ],
            },
            {
                name: 'firstname',
                label: 'Prénom *',
                type: 'text',
                errorMessage: 'Le prénom est requis',
                required: true,
            },
            {
                name: 'lastname',
                label: 'Nom *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                required: true,
            },
            {
                name: 'email',
                label: 'Email * (Si vous changez celui-ci, il vous faudra vous re-connecter)',
                type: 'text',
                errorMessage: "L'email est requis",
                required: true,
            },
            {
                name: 'phone',
                label: 'Téléphone',
                type: 'text',
            },
            {
                name: 'mobile',
                label: 'Mobile',
                type: 'text',
            },
            {
                name: 'birthdate',
                label: 'Date de naissance',
                type: 'date',
            },

            {
                name: 'logo',
                label: 'Inserrer Le Logo de Votre Entreprise au Format H x L : 200x100',
                type: 'image_as_array',
                slug: 'logoImage',
                accept: 'image/*',
            },


            {
                name: 'signature',
                label: 'Signature',
                type: 'quillEditor',
            },

            {
                name: 'address',
                type: 'address',
                fields: {
                    street: {
                        label: 'Adresse',
                        name: 'street',
                    },
                    street2: {
                        label: `Complément d'adresse`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal',
                        name: 'postal_code',
                    },
                    city: {
                        label: 'Ville',
                        name: 'city',
                    },
                },
            },

            {
                name: 'personal_color',
                label: 'Personnaliser l\'outil à votre couleur',
                type: 'color',
            },

            
          
        ];
    }

    defaultValue: any | null = {
        civility: null,
        firstname: null,
        lastname: null,
        company: null,
        roles: null,
        email: null,
        birthdate: null,
        personal_color: null,
        signature: null,
        phone: null,
        mobile: null,
        logo: null,
        address: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
        country: null,
        enabled: false,
        work_habits: null,
        sales_targets: null,
        tax_realization: null,
        ca_realization: null,
    };

    async mounted() {
        this.loading = true;

        const dataUser = await getConnectedUser();
        this.user = dataUser.data;


     
        const userPrimaryColor = this.getUserPrimaryColor(); 
                if (userPrimaryColor) {
                this.setPrimaryColor(userPrimaryColor);
                }

        if (this.user) {
            this.defaultValue.civility = this.user.civility || null;
            this.defaultValue.firstname = this.user.firstname || null;
            this.defaultValue.lastname = this.user.lastname || null;
            this.defaultValue.company = this.user.company
                ? this.user.company.id
                : null;
            this.defaultValue.email = this.user.email || null;
            this.defaultValue.personal_color = this.user.personal_color || '#891a2b';
            this.defaultValue.birthdate =
                (this.user.birthdate && moment(this.user.birthdate)) || null;
            this.defaultValue.signature = this.user.signature || null;
            this.defaultValue.phone = this.user.phone || null;
            this.defaultValue.mobile = this.user.mobile || null;
            this.defaultValue.address.street =
                (this.user.address && this.user.address.street) || null;
            this.defaultValue.address.street2 =
                (this.user.address && this.user.address.street2) || null;
            this.defaultValue.address.postal_code =
                (this.user.address && this.user.address.postal_code) || null;
            this.defaultValue.address.city =
                (this.user.address && this.user.address.city) || null;
            this.defaultValue.address.country =
                (this.user.address && this.user.address.country) || null;
            this.defaultValue.enabled = this.user.enabled;
            this.defaultValue.work_habits = this.user.work_habits || null;
            this.defaultValue.sales_targets = this.user.sales_targets || null;
            this.defaultValue.tax_realization =
                this.user.tax_realization || null;
            this.defaultValue.ca_realization = this.user.ca_realization || null;

            // Charger l'image du logo si elle existe
            if (this.user.logo_image) {
                this.defaultImages = `${BACKEND_URL}${this.user.logo_image.url}${this.user.logo_image.name}.${this.user.logo_image.extension}`;
            }
        }
        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const newUser: User = {
            civility: form.civility,
            firstname: form.firstname,
            lastname: form.lastname,
            email: form.email,
            birthdate: form.birthdate,
            personal_color: form.personal_color,
            signature: form.signature,
            phone: form.phone,
            mobile: form.mobile,
            address: {
                street: form.address.street,
                street2: form.address.street2,
                postal_code: form.address.postal_code,
                city: form.address.city,
            },
            enabled: form.enabled,
            work_habits: form.work_habits,
            sales_targets: form.sales_targets,
            tax_realization: form.tax_realization,
            ca_realization: form.ca_realization,
            // Ajouter le logo s'il existe
            logo_images: form.logo,
        };

        const $vs = (this as any).$vs;

        try {
            await patchConnectedUser(newUser);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Modification',
                text: `Modification réussie`,
            });

            await AuthModule.getUser();

            if (origin) {
                router.push({ name: origin });
            } else {
                router.push({ name: 'home' });
            }
        } catch (error) {
            this.errors = error.response.data.errors.children;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Erreur lors de la soumission du formulaire',
            });
        } finally {
            this.loading = false;
        }
    }




                setPrimaryColor(hexColor: string): void {
                const r: number = parseInt(hexColor.slice(1, 3), 16);
                const g: number = parseInt(hexColor.slice(3, 5), 16);
                const b: number = parseInt(hexColor.slice(5, 7), 16);
                
                document.documentElement.style.setProperty('--primary-color', hexColor);
        
                document.documentElement.style.setProperty('--vs-primary', `${r}, ${g}, ${b}`);
                document.documentElement.style.setProperty('--vs-personal_color', `${r}, ${g}, ${b}`);
            }

            getUserPrimaryColor(): string {
                const authJson = localStorage.getItem('auth')
                if (authJson) {
                    try {
                    const auth = JSON.parse(authJson)
                    return auth.personal_color || '#ff5733'
                    } catch {
                    return '#ff5733'
                    }
                }
                return '#ff5733'
                }

            initializeUserColor(): void {
                const personalColor = this.getUserPrimaryColor();
                this.setPrimaryColor(personalColor);
            }




 async handlePhotoUpload(event: Event) {
    const target = event.target as HTMLInputElement;
    if (!target.files || target.files.length === 0) return;

    const file = target.files[0];
    const reader = new FileReader();
    
    reader.readAsDataURL(file);
    reader.onloadend = async (e: any) => {
        const img = new Image();
        img.onload = async () => {
            const canvas = document.createElement('canvas');
            canvas.width = 200;
            canvas.height = 200;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;

            const ratio = img.width / img.height;
            let dw, dh, dx = 0, dy = 0;
            
            if (ratio > 1) {
                dh = 200;
                dw = img.width * (200 / img.height);
                dx = -(dw - 200) / 2;
            } else {
                dw = 200;
                dh = img.height * (200 / img.width);
                dy = -(dh - 200) / 2;
            }
            
            ctx.drawImage(img, dx, dy, dw, dh);
            const resizedData = canvas.toDataURL(file.type);

            const payload = {
                photo_images: [{
                    name: file.name,
                    file: resizedData,
                    slug: 'photoImage'
                }]
            };

            const $vs = (this as any).$vs;
            try {
                await uploadUserPhoto(payload);
                $vs.notify({
                    color: 'success',
                    title: 'Succès',
                    text: 'Photo mise à jour'
                });
                
                // Reload user data
                const resp = await getConnectedUser();
                this.user = resp.data;
                await AuthModule.getUser();
                
            } catch (error) {
                $vs.notify({
                    color: 'danger',
                    title: 'Erreur',
                    text: 'Impossible de mettre à jour la photo'
                });
            }
        };
        img.src = e.target.result;
    };
}








}
